import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, ClipboardListIcon, BarChart3Icon, TimerIcon, MessageSquareIcon, UserCheckIcon } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1 — Planilla de Planificación Anual',
  icon: CalendarDaysIcon
}, {
  title: 'Bono 2 — Banco de 50 Ejercicios con Descripción Completa',
  icon: ClipboardListIcon
}, {
  title: 'Bono 3 — Planilla de Scouting y Estadísticas de Partido',
  icon: BarChart3Icon
}, {
  title: 'Bono 4 — 12 Semanas de Entrenamientos Listos para Usar',
  icon: TimerIcon
}, {
  title: 'Bono 5 — Guía de Comunicación con Padres + Mensajes Tipo',
  icon: MessageSquareIcon
}, {
  title: 'Bono 6 — Planilla de Evaluación Individual de Jugadores',
  icon: UserCheckIcon
}];
export function Bonuses() {
  return <section className="w-full bg-orange-50 py-12 md:py-16 px-4" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-14">
            De regalo con tu compra
          </h2>
          <p className="text-lg text-orange-600 font-semibold" data-id="element-15">
            🎁 6 Bonos GRATIS solo por hoy
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-16">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="flex items-center gap-3 bg-white rounded-lg shadow-md border-2 border-orange-200 p-5" data-id="element-17">
                <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0" data-id="element-18">
                  <Icon className="w-6 h-6 text-blue-600" data-id="element-19" />
                </div>
                <h3 className="text-base md:text-lg font-bold text-gray-900" data-id="element-20">
                  {bonus.title}
                </h3>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-xl md:text-2xl font-bold text-center text-gray-900 leading-relaxed" data-id="element-21">
          Improvisar un entrenamiento no parece grave.{' '}
          <span className="text-orange-500" data-id="element-22">
            Hasta que pasan los meses y los jugadores siguen cometiendo
            exactamente los mismos errores.
          </span>
        </motion.p>
      </div>
    </section>;
}